module.exports = false;



/*****************
 ** WEBPACK FOOTER
 ** /~/core-js/modules/_library.js
 ** module id = 22
 ** module chunks = 9
 **/